import { createSelector } from 'redux-starter-kit';

const accountSelector = createSelector(['account'], app => app);
